import React, { Component } from "react";
import ButtonSave from "../Button/ButtonSave";
import ButtonPurchase from "../Button/ButtonPurchase";
import CartTotals from "../CartTotals";
import ButtonEdit from "../Button/ButtonEdit";
import ButtonBackUpt from "../Button/ButtonBackUpt";
import IndexRingSize from "../CartTotals/IndexRingSize";
import ButtonMarket from "../Button/ButtonMarket";
import { URL_SERVER, TYPE_NEXT_SAVE, TYPE_NEXT_PURCHASE, URL_SERVER_UPT } from '../../const'

export default class Header extends Component {
  render() {
    return (
      <header className="header">
        <div className="container">
          <div className="header_wrap">
            <div className="header_left">
              <a href={URL_SERVER_UPT}>
              <img src="/img/logo-upt.png" alt="Pasral tool" />
              </a>
              <ButtonBackUpt {...this.props} />
              <ButtonEdit {...this.props} />
              <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_SAVE} />
              <div className="drop-down-upt" style={{width:'200px'}}>
                <span>定番Ｔシャツ</span>
                <svg className={'icon-upt'}>
                  <use xlinkHref={`#icon-list`} />
                </svg>
              </div>
              <div className="drop-down-upt">
                <span className="color">
                </span>
                <span>ホワイト</span>
                <svg className={'icon-upt'}>
                  <use xlinkHref={`#icon-list`} />
                </svg>
              </div>
              <div className="drop-down-upt">
                <span>表</span>
                <svg className={'icon-upt'}>
                  <use xlinkHref={`#icon-list`} />
                </svg>
              </div>
            </div>

            <div className="header_left-sp">
              <div className="app-header">
                <button className="button blue hamburger-button" type="button">
                  <svg className="icon-upt-sp">
                    <use xlinkHref={`#icon-hamburger`} />
                  </svg>
                </button>
                <ButtonBackUpt {...this.props} />
                <IndexRingSize {...this.props} />
                <div className="header_btn-sp">
                  <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_PURCHASE} />
                </div>
              </div>
            </div>

            <div className="header_right hidden_sp">
              <div className="header_action">
                {/*<CartTotals {...this.props} />*/}
                <IndexRingSize {...this.props} />
                <div className="header_btn">
                  <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_PURCHASE} />
                </div>
              </div>
            </div>
            <div className="header_right show_sp">
              <div className="header_action">
                {/*<ButtonMarket {...this.props} />*/}
                {/*<ButtonEdit {...this.props} />*/}
                <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_PURCHASE} />
              </div>
            </div>


          </div>
        </div>
      </header>
    );
  }
}
